// extracted by mini-css-extract-plugin
export default {"registration-button":"G8lvV3","registrationButton":"G8lvV3","disabled":"zFoord","primary":"YGXEUi","secondary":"MfcLBU","link":"RLfKjV","narrowerButton":"SmxfDk"};